
import { defineComponent, ref } from 'vue';

export default defineComponent({
  props: {
    title: String,
    item: Object
  },
  setup() {

    const visible = ref<boolean>(false);

    const showModal = () => {
      visible.value = true;
    };

    const handleOk = (e: MouseEvent) => {
      visible.value = false;
    };

    const handleCancel = () => {
      visible.value = false;
    };

    return {
      visible,
      showModal,
      handleOk,
      handleCancel
    };
  },
});
